import MuiDialogContent, { DialogContentProps } from '@mui/material/DialogContent';
import Box from '../Box';

export interface IDialogContentProps extends DialogContentProps { };

const DialogContent = (props: IDialogContentProps): JSX.Element => {
  return (
    <MuiDialogContent
      {...props}
      sx={{
        ...props.sx,
        m: 0, p: 0
      }}
    >
      <Box padding={1}>
        {props.children}
      </Box>
    </MuiDialogContent>
  );
};

export default DialogContent;
